<template>
  <div v-if="deal">
    <h4>Deal Details</h4>

    <dl class="deal-details-grid">
      <template v-for="item in dealItemsToDisplay">
        <dt :key="'title-' + item.key">{{ item.key | friendlyDisplayKeys }}</dt>
        <dd :key="'value-' + item.key">{{ deal[item.key] | friendlyDisplayValue(item.key) }}</dd>
      </template>
    </dl>

    <v-divider class="section-divider condensed"></v-divider>
    <h4>Lenders In Deal</h4>

    <template>
      <dl class="deal-lender-grid">
        <dt>Lender</dt>
        <dt>Rank in match</dt>
        <dt>User contacted</dt>
        <template v-for="match in deal.matches">
          <dd :key="'dd-name-' + match.id">
            <router-link
              class="default-btn link"
              :to="{
                name: 'OrganizationProductsEdit',
                params: { organizationId: match.product.organizationId, productId: match.productId }
              }"
            >{{ match.product.internalName || match.product.title }}</router-link>
          </dd>
          <dd :key="'dd-rank-' + match.id">
            {{ match.featured ? 'Featured Product' : match.rank }}
          </dd>
          <dd :key="'dd-contacted-' + match.id">
            {{ !!match.contactedAt ? 'Yes' : 'No' }}
          </dd>

        </template>
      </dl>
    </template>
  </div>
</template>

<script>
export default {
  name: 'CondensedUserDealDetails',
  props: {
    deal: Object,
  },
  data: () => ({
    dealItemsToDisplay: [
      { key: 'dealType' },
      { key: 'practiceType' },
      { key: 'dealSize' },
      { key: 'creditScore' },
      { key: 'loanPaymentTerms' },
      { key: 'loanType' },
      { key: 'lenderFeatures' },
      { key: 'hasDisclosureEvents' },
      { key: 'hasRegulatoryIssues' },
      { key: 'speedOfClosing' },
    ],
  }),
  methods: {
    hasOnlyFeaturedMatches (deal) {
      return deal.dealLenders.every(dl => this.matchedBecauseFeatured(dl))
    },
    matchedBecauseFeatured (dealLender) {
      return dealLender.rank === -1
    },
  },
}
</script>

<style lang="scss" scoped>
h4 {
  padding-bottom: 5px;
}

dl {
  display: grid;
  grid-gap: 5px 20px;
  padding: 10px;

  dt {
    font-weight: bold;
    min-width: 50px;
  }

  &.deal-details-grid {
    grid-template-columns: auto 1fr;
  }

  &.deal-lender-grid {
    grid-template-columns: auto auto auto;
  }
}

::v-deep {
  tr.v-data-table__expanded__content {
    td {
      padding-top: 10px;
      padding-bottom: 10px;
    }
  }
}
</style>
